import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=28d5c8e0&scoped=true&"
import script from "./customers.vue?vue&type=script&lang=ts&"
export * from "./customers.vue?vue&type=script&lang=ts&"
import style0 from "./customers.vue?vue&type=style&index=0&id=28d5c8e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d5c8e0",
  null
  
)

export default component.exports